exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal.modal-fullscreen .modal-dialog[data-v-79423887]{width:100vw;height:100vh;margin:0;padding:0;max-width:none}.modal.modal-fullscreen .modal-content[data-v-79423887]{height:auto;height:100vh;border-radius:0;border:none}.modal.modal-fullscreen .modal-body[data-v-79423887]{overflow-y:auto}", ""]);

// exports
